// Lightweight client for the Fittin retailer dashboard.
//
// Auth modes:
//  - Operator: sessionStorage `fittin_dashboard_token` → x-dashboard-token header
//  - Demo link: ?demo=<slug>&t=<token> in URL → forwarded as query params, no header

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "fittin_dashboard_token";

export function getDashboardToken() {
  try {
    return sessionStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setDashboardToken(value) {
  try {
    sessionStorage.setItem(KEY, value);
  } catch {
    /* ignore */
  }
}

export function clearDashboardToken() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// Reads ?demo=<slug>&t=<token> from current URL (or a passed-in URLSearchParams).
export function readDemoParams(search = window.location.search) {
  const p = new URLSearchParams(search);
  const slug = p.get("demo");
  const t = p.get("t");
  if (slug && t) return { slug, t };
  return null;
}

function buildAuth(demoParams) {
  // Demo link path: pass slug+token as query, no header.
  if (demoParams) {
    return {
      params: { prospect: demoParams.slug, t: demoParams.t },
      headers: {},
    };
  }
  return { params: {}, headers: { "x-dashboard-token": getDashboardToken() } };
}

export async function fetchOverview(demo, demoParams = null) {
  const auth = buildAuth(demoParams);
  const r = await axios.get(`${API}/dashboard/overview`, {
    params: { demo, ...auth.params },
    headers: auth.headers,
  });
  return r.data;
}

export async function fetchProducts(demo, filters = {}, demoParams = null) {
  const auth = buildAuth(demoParams);
  const r = await axios.get(`${API}/dashboard/products`, {
    params: { demo, ...auth.params, ...filters },
    headers: auth.headers,
  });
  return r.data;
}

export async function fetchCustomers(demo, demoParams = null) {
  const auth = buildAuth(demoParams);
  const r = await axios.get(`${API}/dashboard/customers`, {
    params: { demo, ...auth.params },
    headers: auth.headers,
  });
  return r.data;
}

// Operator-only: generate a signed demo link for a prospect.
// Requires an admin token (separate from dashboard password).
export async function createDemoLink(prospect, adminToken) {
  const r = await axios.post(
    `${API}/dashboard/demo-link`,
    { prospect },
    { headers: { "x-admin-token": adminToken } }
  );
  return r.data;
}
